module.exports = __webpack_public_path__ + "media/site_templates/www.localhomebuilders.net.au/images/splash-87f77b0785c94f97d1cfe7b59ff9f0cb.jpeg";